import { IMainMenuViewOption, MenuObject } from '@rbi-ctg/menu';
import { routes } from 'utils/routing';

export const optionToUrl = (option: IMainMenuViewOption | MenuObject) =>
  `${routes.menu}/${option._type}-${option._id}`;
